import { BarChartOutlined, ClockCircleOutlined, ExceptionOutlined, ExportOutlined, VerticalAlignTopOutlined, ReloadOutlined, StarFilled, UnorderedListOutlined } from "@ant-design/icons";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import { Button, Card, Col, DatePicker, Divider, Empty, Input, Modal, Popconfirm, Row, Select, Space, Switch, Tabs, Tag, Typography, Tooltip } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import { error_message, success_message } from "../../components/Toastr";
import { TreeSelectLocationUser } from '../../components/TreeSelectLocation';
import { TreeSelectTopic } from '../../components/TreeSelectTopic';
import { UserPicker } from "../../components/UserPicker";
import { ACTION, FEATURE } from "../../config/roles";
import { useAuth } from '../../hooks/auth';
import Api, { exceptionNotificationAPI } from '../../services/api';
import useWindowDimensions from "../../services/useWindowDimensions";
import { truncateString } from "../../utils";
import ExportForm from './export';
import ScheduleForm from './form';
import { FormImportTasks } from './formImportTasks';
import Forms from "./forms";
import { buildStatusAnswerList, parseFormListToTable, parseTaskListToTable } from './helper';
import { TaskHistoryTableBody } from "./history";
import FormBoard from "./newHome/forms";
import TaskBoardView from "./newHome/kanban";
import QuickActionCards from "./newHome/quickActions";
import Reports from "./reports";
import { Container, ContentPanelIndex, FullCalendarContainer } from './styles';
import WorkflowTab from "./workflow";

const { Text, Title } = Typography;
const { TabPane } = Tabs;
const { Search } = Input;
const { OptGroup } = Select;
const { confirm } = Modal;

function getScheduleDropdownStatusOptions() {
  return ['Late', 'Open', 'Pending', 'Recurrency', 'Approval'];
}

function getHistoryInitialState(filter) {
  // Set default date range if no dates provided
  let startDate = filter?.startDate;
  let endDate = filter?.endDate;

  if (!startDate && !endDate) {
    const today = dayjs();
    const oneMonthAgo = today.subtract(1, 'month');
    startDate = oneMonthAgo.format('YYYY-MM-DD');
    endDate = today.format('YYYY-MM-DD');
  }

  return ({
    isAdmin: false,
    reportToHistory: filter?.reportToHistory !== undefined ? filter.reportToHistory : 1, // Preserve existing value, default to My Tasks only if undefined
    locationId: filter?.locationId,
    locationIncludeChildren: filter?.locationIncludeChildren ?? false,
    topicId: filter?.topicId,
    searchText: filter?.searchText,
    status: filter?.status,
    orderField: "InsertDate",
    ascendingOrder: false,
    pageNumber: 1,
    pageSize: 10,
    formId: filter?.formId || null,
    formQuestionId: null,
    formQuestionValue: null,
    startDate: startDate,
    endDate: endDate,
  });
}

const HomeWrapper = () => {
  return (
    <HomeIndex
      filters={null}
    />
  )
};

const HomeIndex = (props) => {
  const { filters } = props;

  // Configure dayjs locale based on user language
  const { user, can } = useAuth();
  const currentLanguage = user?.languageId || 'pt-BR';
  const dayjsLocale = currentLanguage === 'en-US' ? 'en' : 'pt-br';

  // Update dayjs locale when language changes
  React.useEffect(() => {
    console.log('Setting dayjs locale:', dayjsLocale, 'for language:', currentLanguage);
    dayjs.locale(dayjsLocale);
    console.log('Current dayjs locale:', dayjs.locale());
  }, [dayjsLocale]);

  const historyTextSearchRef = React.useRef();
  const formAdhocSearchRef = React.useRef();
  const skipOnFormQuestionChange = React.useRef(false);

  const { height } = useWindowDimensions();
  const { t } = useTranslation();
  let navigate = useNavigate();
  const calendarRef = React.createRef();
  const [showModalForm, setShowModalForm] = useState(false);
  const [showReportsSummary, setShowReportsSummary] = useState(false);

  const [loadingTable, setLoadingTable] = useState(true);
  const [loadingTableTaskSchedule, setLoadingTableTaskSchedule] = useState(true);

  const [loadingTableAnswers, setLoadingTableAnswers] = useState(true);
  const [formTaskSelected, setFormTaskSelected] = useState(null);
  const [dateSelected, setDateSelected] = useState(null);

  const [workflowRunning, setWorkflowRunning] = useState(0);
  const [tasksLate, setTasksLate] = useState(0);
  const [tasksOpen, setTasksOpen] = useState(0);
  const [tasksPending, setTasksPending] = useState(0);
  const [tasksDone, setTasksDone] = useState(0);

  const [filterNameSchedule, setFilterNameSchedule] = useState(filters?.searchText ?? "");
  const [searchForList, setSearchForList] = useState([]);
  const [filterStatusSchedule, setFilterStatusSchedule] = useState(filters?.status ?? getScheduleDropdownStatusOptions());

  const [showInfosScreen, setShowInfosScreen] = useState(filters?.tabActive ?? true);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showModalFilter, setShowModalFilter] = useState(false);
  const [tab, setTab] = useState(filters != null && filters.tabActive ? filters.tabActive : 1);




  //Task states
  const [paginationTaskConfig, setPaginationTaskConfig] = useState({
    current: 1,
    total: 0,
  });

  //Answers states
  const [listAnswersdata, setListAnswersdata] = useState(null);
  const [filterAnswersRequest, setFilterAnswersRequest] = useState(getHistoryInitialState(filters));
  const [showOriginInformationProgress, setShowOriginInformationProgress] = useState(false);
  const [paginationAnswersConfig, setPaginationAnswersConfig] = useState({ current: 1, total: 0, pageSize: 10 });
  const [loadingIconAnswersFilter, setLoadingIconAnswersFilter] = useState(false);
  const [statusAnswersList, setStatusAnswersList] = useState();
  const [loadingIconAnswersStatusFilter, setLoadingIconAnswersStatusFilter,] = useState(false);
  const [answersDateRange, setAnswersDateRange] = useState(() => {
    // Initialize with default date range if no filters from sessionStorage
    if (!filters?.startDate && !filters?.endDate) {
      const today = dayjs();
      const oneMonthAgo = today.subtract(1, 'month');
      return [oneMonthAgo, today];
    }
    return null;
  });

  // Flag to track if user has explicitly cleared the date range
  const [dateRangeCleared, setDateRangeCleared] = useState(false);

  // Set default date range for History tab (tab == 2) when no date filter is set
  // Only set default if user hasn't explicitly cleared the date range
  React.useEffect(() => {
    if (tab === 2 && !answersDateRange && !filterAnswersRequest?.startDate && !filterAnswersRequest?.endDate && !dateRangeCleared) {
      const today = dayjs();
      const oneMonthAgo = today.subtract(1, 'month');
      setAnswersDateRange([oneMonthAgo, today]);
      setFilterAnswersRequest(prev => ({
        ...prev,
        startDate: oneMonthAgo.format('YYYY-MM-DD'),
        endDate: today.format('YYYY-MM-DD')
      }));
    }
  }, [tab, answersDateRange, dateRangeCleared]);

  // Load form questions when formId is set from filters
  React.useEffect(() => {
    if (filterAnswersRequest?.formId && tab === 2) {
      getQuestionsFromForm(filterAnswersRequest.formId);
    }
  }, [filterAnswersRequest?.formId, tab]);

  //Task Schedule states
  const [listTaskScheduledata, setListTaskScheduledata] = useState(null);
  const [filterTaskScheduleRequest, setFilterTaskScheduleRequest] = useState({
    userId: '',
    schedule: true,
    isAdmin: false,
    reportToHistory: filters?.reportToHistory ?? 1,
    withHistory: true,
    date: dayjs().startOf('day'),
    startDate: '',
    endDate: '',
    status: '',
    locationId: '',
    orderField: 'ScheduleDate',
    ascendingOrder: true,
    pageNumber: 1,
    pageSize: 99999,
  });

  const [listFormOptions, setListFormOptions] = useState(null);
  const [listFormQuestionOptions, setListFormQuestionsOptions] = useState(null);
  const [listFormQuestionLoading, setListFormQuestionsLoading] = useState(false);

  // Set selectedValue when formId changes from filters
  React.useEffect(() => {
    if (filterAnswersRequest?.formId && listFormOptions && tab === 2) {
      const selectedForm = listFormOptions.find(option => option.value === filterAnswersRequest.formId);
      if (selectedForm) {
        // Update selectedValue with the form from listFormOptions to ensure correct label
        setSelectedValue({ label: selectedForm.label, value: selectedForm.value });
      }
      // If form not found in listFormOptions but formId is set, keep current selectedValue
      // This handles the case when form is selected from Reports tab before listFormOptions loads
    } else if (!filterAnswersRequest?.formId && tab === 2) {
      // Clear selection when formId is cleared
      setSelectedValue({ label: null, value: null });
    }
  }, [filterAnswersRequest?.formId, listFormOptions, tab]);

  useEffect(() => {
    if (loadingTable) {
      //Answers
      getAnswersStatusData();
    }
  }, []);

  useEffect(() => {
    if ((user?.profiles != undefined || user?.profiles != null) && user?.profiles.filter(f => f.role.name === "Administrator").length == 0 && user?.customHomePage) {
      navigate("/home/custom");
    }
    setFilterAnswersRequest({
      ...filterAnswersRequest,
      isAdmin: (user?.profiles != undefined || user?.profiles != null) && user?.profiles.filter(f => f.role.name === "Administrator").length > 0
    });
    setFilterTaskScheduleRequest({ ...filterTaskScheduleRequest });
    if (!can(FEATURE.SCHEDULE, [ACTION.VIEW])) {
      handleChangeTab(2);
    }
  }, [user?.profiles])

  //Controla a exibição das informações da tabela, para a tag de pagination não carregue primeiro que as listas
  useEffect(() => {
    if (listTaskScheduledata != null) {
      setShowInfosScreen(true);
    }
  }, [listTaskScheduledata]);

  useEffect(() => {
    if (tab != 2) return;

    // Se estiver no modo resumo, não precisa carregar as tarefas
    if (showReportsSummary) return;

    // se veio de uma mudança de formQuestionId, reseta o flag e NÃO roda o fetch
    if (skipOnFormQuestionChange.current == true) {
      skipOnFormQuestionChange.current = false;
      return;
    }

    setLoadingTableAnswers(true);
    getAnswersListData();
  }, [filterAnswersRequest, showReportsSummary]);

  const [loadingTableApprovalTask, setLoadingTableApprovalTask] = useState(true);
  const [loadingTableFavorite, setLoadingTableFavorite] = useState(true);
  //Form states
  const [listFavoritedata, setListFavoritedata] = useState(null);
  const [filterFavoriteRequest, setFilterFavoriteRequest] = useState({
    locationId: '',
    topicId: '',
    searchText: '',
    status: 'Active',
    orderField: 'InsertDate',
    adhoc: true,
    validatePeriod: true,
    ascendingOrder: false,
    pageNumber: 1,
    pageSize: 999,
  });

  const [listTaskApprovalData, setListTaskApprovalData] = useState(null);

  useEffect(() => {
    if (tab == 1) {
      setLoadingTableFavorite(true);
      getFavoriteListData();
    }
  }, [filterFavoriteRequest]);

  useEffect(() => {
    if ((tab == 1 || tab == 2) && user?.profiles != undefined) {
      getTaskScheduleListData();
    }
  }, [filterTaskScheduleRequest]);


  const getTaskScheduleListData = useCallback(() => {
    setLoadingTableTaskSchedule(true);
    var r = filterTaskScheduleRequest.reportToHistory;
    if (r != 1 && r != 2 && r != 3) {
      // Don't modify the original object, create a new one
      const updatedRequest = {
        ...filterTaskScheduleRequest,
        reportToHistory: 1
      };
      setFilterTaskScheduleRequest(updatedRequest);
      return; // Exit early to avoid the API call with invalid data
    }

    Api.post('/Task/getAll', filterTaskScheduleRequest)
      .then(response => {
        if (response.data) {
          let tasklist = parseTaskListToTable(response.data);
          setListTaskScheduledata(tasklist);

          setLoadingTable(false);
          setLoadingTableTaskSchedule(false);
        }
      })
      .catch(error => {
        let message = 'Failed to load the list!';
        if (/500/.test(error.message)) {
          message = t('Prompt.Webserver.Error');
        }
        setLoadingTableTaskSchedule(false);
        error_message(message);
      });
  });

  const getAnswersListData = useCallback(() => {
    setLoadingTableAnswers(true);
    setShowOriginInformationProgress(false);
    var r = filterAnswersRequest?.reportToHistory;
    if (r != 1 && r != 2 && r != 3) {
      // Don't modify the original object, create a new one
      const updatedRequest = {
        ...filterAnswersRequest,
        reportToHistory: 1
      };
      setFilterAnswersRequest(updatedRequest);
      return; // Exit early to avoid the API call with invalid data
    }

    // Load form options only once
    if (listFormOptions == null) {
      Api.post('/Form/getAllSelectBase', null).then(r => {
        const formOptions = r.data.response.map(i => {
          return {
            label: i.name,
            value: i.baseId,
          }
        });
        setListFormOptions(formOptions);
      })
        .catch(error => {
          exceptionNotificationAPI(error);
          setLoadingTableAnswers(false);
        });
    }

    Api.post('/FormTask/getAll', filterAnswersRequest)
      .then(response => {
        if (response.data) {
          let tasklist = parseTaskListToTable(response.data);
          setListAnswersdata(tasklist);

          setWorkflowRunning(response.data.response.workflowRunning);
          setTasksLate(response.data.response.tasksLate);
          setTasksOpen(response.data.response.tasksOpen);
          setTasksPending(response.data.response.tasksPending);
          setTasksDone(response.data.response.tasksDone);

          if (filterAnswersRequest?.formId) {
            let list = tasklist.filter((i) => i.hasOriginInformationQuestions);
            let showOrigin = list.length > 0;
            setShowOriginInformationProgress(showOrigin);
          }

          let tempPaginationConfig = {
            ...paginationTaskConfig,
            current: filterAnswersRequest?.pageNumber,
            total: response.data.response.rowCount,
            pageSize: filterAnswersRequest?.pageSize || 10,
          };

          setLoadingTable(false);
          setLoadingTableAnswers(false);
          setLoadingIconAnswersFilter(false);
          setLoadingIconAnswersStatusFilter(false);
          setPaginationAnswersConfig(tempPaginationConfig);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
        setLoadingTableAnswers(false);
      });
  }, [filterAnswersRequest, listFormOptions, paginationTaskConfig]);

  const onChangeAnswersTablePagination = (page, pageSize) => {
    let tempPaginationConfig = {
      ...paginationAnswersConfig,
      current: page,
      pageSize: pageSize || paginationAnswersConfig.pageSize,
    };

    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: page,
      pageSize: pageSize || filterAnswersRequest.pageSize,
    };

    setPaginationAnswersConfig(tempPaginationConfig);
    setFilterAnswersRequest(tempFilterRequest);
  };

  const renderFavoriteTable = () => {
    if (!listFavoritedata) return <></>;

    if (listFavoritedata.length == 0)
      return <Empty />

    var table = listFavoritedata.filter(x => x.adhoc).map((item, index) => {
      return <>
        <Link
          to={{
            pathname: `/formbuilder/apply/${item.id}`,
            state: { redirectURL: "/home" }
          }}
          key={item.id}
          style={{ color: '#000' }}
          title={"Click to answer form - " + item.title}
        >
          <Row gutter={8} wrap={false}>
            <Col span={1}>
              <StarFilled style={{ fontSize: 16, color: "#f9d71c" }} twoToneColor="#f9d71c" />
            </Col>
            <Col span={23}>
              <Row gutter={8}>
                <Col span={24}>
                  {item.title}
                </Col>
                <Col span={24}>
                  <Text type="secondary">{`${t('Location')}: ${item.location.locationPath?.join(" | ") ?? item.location.name}`}</Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Link>
        {index + 1 < listFavoritedata.filter(x => x.adhoc).length && <Divider />}
      </>;
    });

    return (
      <div style={{ overflowY: "auto", maxHeight: "320px", paddingRight: 8 }}>
        {table}
      </div>
    );
  };

  const renderApprovalTable = () => {
    if (!listTaskApprovalData) return <></>;

    if (listTaskApprovalData.length == 0)
      return <Empty />

    const table = listTaskApprovalData.map((item, index) => {
      let languageId = "";
      if (item.languageId)
        languageId = `?languageId=${item.languageId}`;

      return (
        <React.Fragment key={item.id}>
          <Link
            to={{
              pathname: `/formbuilder/view-answer/${item.id + languageId}`,
              state: { redirectURL: "/home" }
            }}
            style={{ color: '#000' }}
            title={t("OpViewAnswer")}
          >
            <Row gutter={8} wrap={false}>
              <Col span={1}>
                <ExceptionOutlined style={{ fontSize: 16, color: "#4085c6" }} />
              </Col>
              <Col span={23}>
                <Row gutter={8}>
                  <Col span={24}>{item.title}</Col>
                  <Col span={24}>
                    <Text type="secondary">{`${t('Code')}: ${item.friendlyId}`}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Link>
          {index + 1 < listTaskApprovalData.length && <Divider />}
        </React.Fragment>
      );
    });

    // Adiciona um div com overflow para scroll
    return (
      <div style={{ overflowY: "auto", maxHeight: "320px", paddingRight: 8 }}>
        {table}
      </div>
    );
  };

  const handleAnswersSearchFilter = value => {
    value ? setLoadingIconAnswersFilter(true) : setLoadingIconAnswersFilter(false);

    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      searchText: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchTopic = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      topicId: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchUser = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      userId: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchCreatedUser = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      created: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchForm = (value, option) => {
    const label = option?.label || value;

    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      formId: value,
      formQuestionId: null,
      formQuestionValue: null
    };

    if (value && value != null)
      getQuestionsFromForm(value);

    setSelectedValue({ label, value });

    setFilterAnswersRequest(tempFilterRequest);

    if (!value || option.label == '' || option.label == null) {
      setSelectedValue({ label: '', value: '' });
    }
  };

  const handleAnswersSearchFormQuestion = value => {
    skipOnFormQuestionChange.current = true;
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      formQuestionId: value,
      formQuestionValue: null
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchFormQuestionValue = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      formQuestionValue: value
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const getQuestionsFromForm = async (formId) => {
    setListFormQuestionsLoading(true);
    Api.get('/Form/getAllQuestionSelect?formId=' + formId).then(r => {
      const formQuestionsOptions = r.data.response.map(i => {
        return {
          label: i.name,
          value: i.trackingId ?? i.id,
          choices: i.options || []
        }
      });

      setListFormQuestionsOptions(formQuestionsOptions);
      setListFormQuestionsLoading(false);
    })
      .catch(error => {
        exceptionNotificationAPI(error);
        setListFormQuestionsLoading(false);
      });
  }

  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(null);

  const filterOption = (input, option) => {
    const label = option.label || '';
    return label.toLowerCase().includes(input.toLowerCase());
  };

  const onSearch = (value) => {
    setSearchValue(value);
    const filtered = listFormOptions.filter(option => (option.label || '').toLowerCase().includes(value.toLowerCase()));
    setFilteredOptions(filtered);
  };

  const [selectedValue, setSelectedValue] = useState({ label: null, value: '' });

  const handleClear = () => {
    setFilteredOptions([]);
    setSearchValue(null);
    setSelectedValue({ label: null, value: null });
  };

  const renderAnswersFormDropdown = () => {
    return (
      <Row gutter={[8, 8]}>
        <Col span={8}>
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder={t("History.Form")}
            onSearch={onSearch}
            className="space-search"
            options={filteredOptions.length > 0 ? filteredOptions : listFormOptions}
            filterOption={filterOption}
            onChange={handleAnswersSearchForm}
            onClear={handleClear}
            value={selectedValue.value || undefined}
            disabled={loadingTableAnswers}
          />
        </Col>

        {/* Só mostra filtros de questão quando NÃO estiver no modo resumo */}
        {!showReportsSummary && filterAnswersRequest?.formId != null && (
          <Col span={8}>
            <Select
              className="space-search"
              allowClear
              loading={listFormQuestionLoading}
              placeholder={t("History.FormQuestion")}
              disabled={loadingTableAnswers}
              options={listFormQuestionOptions}
              onChange={handleAnswersSearchFormQuestion}
              value={filterAnswersRequest?.formQuestionId}
            />
          </Col>
        )}

        {!showReportsSummary && filterAnswersRequest?.formQuestionId != null && (
          <Col span={8}>
            {(() => {
              // encontra a questão atual no seu listFormQuestionOptions
              const current = listFormQuestionOptions.find(o => o.value == filterAnswersRequest.formQuestionId);

              // se tiver opções, renderiza um Select
              if (current?.choices?.length > 0) {
                return (
                  <Select
                    style={{ width: '100%' }}
                    placeholder={t("History.FormQuestionValue")}
                    allowClear
                    disabled={loadingTableAnswers}
                    onChange={handleAnswersSearchFormQuestionValue}
                    value={filterAnswersRequest.formQuestionValue}
                  >
                    {current.choices.map(opt => (
                      <Select.Option key={opt} value={opt}>
                        {opt}
                      </Select.Option>
                    ))}
                  </Select>
                );
              }

              // caso contrário, mantém o Input.Search
              return (
                <Input.Search
                  style={{ width: '100%' }}
                  allowClear
                  loading={listFormQuestionLoading}
                  placeholder={t("History.FormQuestionValue")}
                  onSearch={handleAnswersSearchFormQuestionValue}
                  disabled={loadingTableAnswers}
                  defaultValue={filterAnswersRequest.formQuestionValue}
                />
              );
            })()}
          </Col>
        )}
      </Row>
    );
  }

  const renderAnswersTopicDropdown = () => {
    return (
      <TreeSelectTopic
        placeholder={t('Topic.Title')}
        onChange={handleAnswersSearchTopic}
        value={filterAnswersRequest?.topicId}
        disabled={loadingTableAnswers}
        style={{ width: '100%' }}
      ></TreeSelectTopic>
    );
  };

  const renderAnswersLocationDropdown = () => {
    return (
      <TreeSelectLocationUser
        placeholder={t('Location')}
        includeDirectParents={false}
        onChange={handleAnswersSearchLocation}
        value={filterAnswersRequest?.locationId}
        disabled={loadingTableAnswers}
        style={{ width: '100%' }}
      ></TreeSelectLocationUser>
    );
  };

  const renderAnswersLocationBelowDropdown = () => {
    if (filterAnswersRequest?.locationId != undefined && filterAnswersRequest?.locationId != "")
      return (
        <><Switch disabled={loadingTableAnswers} style={{ marginTop: 10 }} value={filterAnswersRequest?.locationIncludeChildren} onChange={handleAnswersSearchLocation2} /> {t('History.LocationBelow')}</>
      );
    else return <></>
  };

  const handleAnswersSearchLocation2 = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      locationIncludeChildren: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchLocation = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      locationId: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const getAnswersStatusData = useCallback(() => {
    let tempStatusList = buildStatusAnswerList();

    setStatusAnswersList(tempStatusList);
  });

  const renderAnswersStatusDropdown = () => {
    if (statusAnswersList == undefined)
      return (<></>);

    let options = statusAnswersList.length > 0
      && statusAnswersList.map((item) => {
        return (
          <Option key={item.id} value={item.id}>{t(item.name)}</Option>
        );
      });

    return (
      <Select
        allowClear
        loading={loadingIconAnswersStatusFilter}
        value={filterAnswersRequest?.status}
        placeholder={t('Status')}
        onChange={handleAnswersSearchStatus}
        disabled={loadingTableAnswers}
        style={{ width: '100%' }}
      >
        <OptGroup label="Tasks">
          {options}
        </OptGroup>
        <OptGroup label="Workflow">
          <Option key={"Running"} value={"Running"}>{t("History.WorkflowRunning")}</Option>
          <Option key={"DoneWorkflow"} value={"DoneWorkflow"}>{t("History.WorkflowDone")}</Option>
        </OptGroup>
      </Select>
    );
  };

  const renderAnswersReportDropdown = () => {
    return (
      <Select
        value={filterAnswersRequest?.reportToHistory}
        placeholder={t('History.Tasks')}
        onChange={handleAnswersReport}
        disabled={loadingTableAnswers}
        style={{ width: '100%' }}
      >
        <Option value={1}>{t('History.MyTasks')}</Option>
        {user?.showOnlyMyTasks !== true ? <Option value={2}>{t('History.LocationTasks')}</Option> : null}
        {user?.showOnlyMyTasks !== true ? <Option value={3}>{t('History.ReportTasks')}</Option> : null}
      </Select>
    );
  };

  const handleAnswersReport = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      reportToHistory: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
  };

  const handleAnswersSearchStatus = value => {
    let tempFilterRequest = {
      ...filterAnswersRequest,
      pageNumber: 1,
      status: value,
    };

    setFilterAnswersRequest(tempFilterRequest);
    setLoadingIconAnswersStatusFilter(true);
  };

  const handleDeleteAnswer = (value, restart, all) => {
    var content = "";
    if (restart && !all)
      content = t('Delete.Content2');
    else if (!restart && all)
      content = t('Delete.Content3');
    else
      content = t('Delete.Content1');

    var config = {
      title: value.title,
      content: content,
      okText: t('BtnYes'),
      onOk() {
        Api.post(`/FormTask/delete?id=${value.id}&restart=${restart}&all=${all}`).then((response) => {
          setLoadingTableAnswers(true);
          getAnswersListData();
          success_message(t('Prompt.Delete'));
        }).catch((error) => {
          let message = "Failed to delete the record!";
          if (/500/.test(error.message)) {
            message = t('Prompt.Webserver.Error');
          }
          error_message(message);
        });
      },
    }

    return confirm(config);
  }

  const handleEditSchedule = (formTask) => {
    let formTaskObj = {
      id: formTask.id,
      disableFormOption: true,
      extendedProps: { //pattern that fullcalendar use
        ...formTask,
        scheduleDate: formTask.scheduleDate,
        userId: formTask.userId,
        formId: formTask.formId,
        status: Array.isArray(formTask.status) ? formTask.status[0] : formTask.status,
        locationId: formTask.locationId,
        history: [],
        option: "notrepeat"
      }
    };
    setFormTaskSelected(formTaskObj);
    setShowModalForm(true);
  }

  const handleReOpenAnswer = value => {
    var config = {
      title: t('ReOpen.Title'),
      content: "Answer: " + value.title,
      okText: t('BtnYes'),
      onOk() {
        Api.post(`/FormTask/reopen?id=${value.id}`).then((response) => {
          setLoadingTableAnswers(true);
          getAnswersListData();
          success_message("Record reopen successfully!");
        }).catch((error) => {
          let message = "Failed to reopen the record!";
          if (/500/.test(error.message)) {
            message = t('Prompt.Webserver.Error');
          }
          error_message(message);
        });
      },
    }

    return confirm(config);
  }

  const handleCloseTask = value => {
    var config = {
      title: t('CloseTask.Title'),
      content: "Answer: " + value.title,
      okText: t('BtnYes'),
      onOk() {
        Api.post(`/FormTask/close?id=${value.id}`).then((response) => {
          setLoadingTableAnswers(true);
          getAnswersListData();
          success_message("Close Task successfully!");
        }).catch((error) => {
          let message = "Failed to close the task!";
          if (/500/.test(error.message)) {
            message = t('Prompt.Webserver.Error');
          }
          error_message(message);
        });
      },
    }

    return confirm(config);
  }

  const renderAnswersTable = () => {
    return (
      <TaskHistoryTableBody
        handleCloseTask={handleCloseTask}
        handleStatus={handleAnswersSearchStatus}
        handleDeleteAnswer={handleDeleteAnswer}
        handleEditSchedule={handleEditSchedule}
        handleReOpenAnswer={handleReOpenAnswer}
        listAnswersdata={listAnswersdata}
        onChangeAnswersTablePagination={onChangeAnswersTablePagination}
        paginationAnswersConfig={paginationAnswersConfig}
        tasksDone={tasksDone}
        tasksOpen={tasksOpen}
        tasksLate={tasksLate}
        tasksPending={tasksPending}
        workflowRunning={workflowRunning}
        showOriginInformationProgress={showOriginInformationProgress}
        formId={filterAnswersRequest?.formId}
      />
    )
  };

  const renderScheduleStatusDropdown = () => {
    if (statusAnswersList == undefined)
      return (<></>);

    let options = statusAnswersList.length > 0
      && statusAnswersList.filter(x => tab == 1 ? x.name != "Done" : true).map((item) => {
        return (
          <Option key={item.id} value={item.id}>{t(item.name)}</Option>
        );
      });

    return (
      <Select
        maxTagCount="responsive"
        allowClear
        mode="multiple"
        placeholder="Status"
        value={filterStatusSchedule}
        defaultValue={getScheduleDropdownStatusOptions()}
        onChange={(e) => {
          setFilterStatusSchedule(e);
        }}
        style={{ width: '100%', marginTop: 5 }}
        disabled={tab == 2 ? loadingTableAnswers : false}
      >
        {options}
      </Select>
    );
  };

  const renderSchedule = () => {
    return <Card style={{ visibility: loadingTableTaskSchedule ? 'hidden' : 'visible' }} >
      <FullCalendarContainer className="font-face-gbold">
        <FullCalendar
          timeZone='UTC'
          height={height - 230}
          expandRows={true}
          ref={calendarRef}
          plugins={[dayGridPlugin, interactionPlugin]}
          headerToolbar={{
            start: can(FEATURE.SCHEDULE, [ACTION.CREATE]) ? 'new myTasks' : 'myTasks',
            center: 'title',
            end: 'prev,next'
          }}
          buttonText={
            {
              month: t('Schedule.Month'),
              list: t('List.Title')
            }
          }
          defaultAllDay={true}
          events={listTaskScheduledata != null && listTaskScheduledata.filter(x => (x.title.toLowerCase().indexOf(filterNameSchedule.toLowerCase()) > -1 || x.friendlyId.indexOf(filterNameSchedule.toLowerCase()) > -1) && filterStatusSchedule.includes(x.status))}
          eventContent={(e) => {
            let status = e.event.extendedProps.status;

            let actionEdit = null;
            if (can(FEATURE.SCHEDULE, [ACTION.EDIT])) {
              actionEdit = "Edit";
            }

            let languageId = "";
            if (e.event.extendedProps.languageId) {
              languageId = `?languageId=${e.event.extendedProps.languageId}`;
            }

            let hasFriendlyId = (e.event.extendedProps.friendlyId != null)
              ? e.event.extendedProps.friendlyId
              : '';

            let isRecurrency = e.event.extendedProps.formScheduleRecurrencyId != null && e.event.extendedProps.formScheduleRecurrencyId != "";

            var documentControl = e.event.extendedProps.taskTypeId == "829855ba-6a28-4013-8440-20ff97078389" || e.event.extendedProps.taskTypeId == "b2b427ee-5199-4459-83fd-d28b3d2c18d2";
            var documentControl1 = e.event.extendedProps.taskTypeId == "829855ba-6a28-4013-8440-20ff97078389";
            var documentControl2 = e.event.extendedProps.taskTypeId == "b2b427ee-5199-4459-83fd-d28b3d2c18d2";

            var taskControl = e.event.extendedProps.taskTypeId == "df3cb0ad-9e0a-44e1-898c-3e3a5df1483e";

            var approvalControl = e.event.extendedProps.taskTypeId == "df3cb0ad-9e0a-44e1-898c-3e3a5df1483e";
            var formTask = e.event.extendedProps.taskTypeId == "ad89b18a-802e-4a51-94ae-bf73e7329a68";
            return <Popconfirm
              title={<><b>Select an option</b> <br />
                {(hasFriendlyId && !isRecurrency) && <>{"Task ID: " + hasFriendlyId}<br /></>}
                <span title={e.event.title}>{"Task: " + truncateString(e.event.title, 50)}</span><br />
                {"User: " + e.event.extendedProps.userName}<br />
                {(hasFriendlyId && !isRecurrency) && <>{"Created at: " + moment(e.event.extendedProps.insertDate).format("YYYY-MMM-DD HH:mm:ss")}<br /></>}
                {documentControl1 && <><b>Document Task</b></>}
                {documentControl2 && <><b>Document Revision</b></>}
                {taskControl && <><b>Form Task</b></>}
                {approvalControl && <><b>Approval Task</b></>}
              </>}
              okText={documentControl ? t('OpViewDocument') : status == "Done" ? t('OpViewAnswer') : t('OpAnswerForm')}
              onConfirm={() => {
                navigate(taskControl ? "/formbuilder/view-answer/" + e.event.extendedProps.taskId + languageId
                  : documentControl ? "/documentcontrol/details/" + e.event.extendedProps.documentId
                    : status == "Done" || status == "Approval" ? "/formbuilder/view-answer/" + e.event.id + languageId
                      : e.event.extendedProps.description == "Fake"
                        ? "/formbuilder/recurrency/" + e.event.extendedProps.formScheduleRecurrencyId + "/" + e.event.extendedProps.scheduleDate + "/" + e.event.extendedProps.scheduleSequence
                        : { pathname: "/formbuilder/apply/" + e.event.extendedProps.formId + "/" + e.event.id, state: { redirectURL: "/home" } })
              }}
              cancelText={documentControl ? documentControl2 ? t('BtnDelete') : t('BtnClose') : actionEdit != null && status != "Done" && (formTask || isRecurrency) ? t('BtnEdit') : t('BtnClose')}
              onCancel={() => {
                setFormTaskSelected(null);
                if (documentControl2) {
                  revisionDeclined(e.event.extendedProps.documentId, e.event.id);
                } else if (!documentControl && actionEdit != null && status != "Done") {
                  setFormTaskSelected(() => { return e.event });
                  setShowModalForm(true);
                }
              }}
            >
              <div>
                <div className={"event-text " + (status == "Open" ? "fc-open" : status == "Approval" ? "fc-approval" : status == "Done" ? "fc-done" : status == "Late" ? "fc-late" : status == "Pending" ? "fc-pending" : status == "Recurrency" ? "fc-recurrency" : "")}>
                  <small>
                    &nbsp;<ClockCircleOutlined />&nbsp; {moment(e.event.extendedProps.scheduleDate).utc().format("HH:mm")}
                  </small>
                  <small style={{ float: "right", marginTop: 3 }}>
                    {hasFriendlyId && !isRecurrency && <>{t('Code')}: {e.event.extendedProps.friendlyId}</>}&nbsp;
                  </small>
                  <br></br>
                  {isRecurrency && <strong>&nbsp;<ReloadOutlined /></strong>}
                  &nbsp;
                  {truncateString(e.event.title, 50)}
                </div>
              </div>
            </Popconfirm>
          }}
          dateClick={(e) => {
            if (can(FEATURE.SCHEDULE, [ACTION.CREATE])) {
              setFormTaskSelected(null);
              setDateSelected(e.date);
              setShowModalForm(true);
            }
          }}
          customButtons={{
            new: {
              text: t('BtnNew'),
              click: async function () {
                setFormTaskSelected(null);
                setDateSelected(undefined);
                setShowModalForm(true);
              }
            },
            prev: {
              text: t('Schedule.Prev'),
              click: async function () {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.prev();
                updateSchedule(moment(filterTaskScheduleRequest.date).add(-1, 'months').startOf('month'));
              }
            },
            next: {
              text: t('Schedule.Next'),
              click: async function () {
                let calendarApi = calendarRef.current.getApi();
                calendarApi.next();
                updateSchedule(moment(filterTaskScheduleRequest.date).add(1, 'months').startOf('month'));
              }
            },
            myTasks: {
              text: t('AsyncTask.Filters'),
              click: async function () {
                setShowModalFilter(true);
              }
            },
          }}
        />
        <Row gutter={[8, 8]} className="footer-container">
          <Col flex={"1 50%"}>
            <Tag color="rgb(199 200 202)">{t('Pending')}</Tag>
            <Tag color="#ff4d4f">{t('Late')}</Tag>
            <Tag color="#4085c6">{t('Open')}</Tag>
            <Tag color="#60a5fa">{t('Approval')}</Tag>
            <Tag color="#34d399">{t('Done')}</Tag>
            <Tag color="#2c84c0">{t('Recurrency')}</Tag>
          </Col>
        </Row>
      </FullCalendarContainer>
    </Card>
  }

  function revisionDeclined(id, idTask) {
    Api.post(`/DocumentControl/revisionDeclined/${id}/${idTask}`, null)
      .then(response => {
        updateSchedule(moment(filterTaskScheduleRequest.date).startOf('month'));
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });
  }

  function updateSchedule(month) {
    let tempFilterRequest = {
      ...filterTaskScheduleRequest,
      pageNumber: 1,
      date: moment(month).add(1, 'days'),
    };
    setFilterTaskScheduleRequest(tempFilterRequest);
  }

  function adminSchedule(reportToHistory) {
    setFilterTaskScheduleRequest({
      ...filterTaskScheduleRequest,
      reportToHistory: reportToHistory,
    });
  }

  function locationSchedule(locationId) {
    setFilterTaskScheduleRequest({
      ...filterTaskScheduleRequest,
      locationId: locationId
    });
  }

  function topicSchedule(topicId) {
    setFilterTaskScheduleRequest({
      ...filterTaskScheduleRequest,
      topicId: topicId
    });
  }

  function locationBelowSchedule(include) {
    setFilterTaskScheduleRequest({
      ...filterTaskScheduleRequest,
      locationIncludeChildren: include
    });
  }

  function handleChangeTab(tabKey) {
    if (tabKey == 1) {
      //schedule calendar 
      setFilterStatusSchedule(getScheduleDropdownStatusOptions());
      adminSchedule(false);
    } else if (tabKey == 2) {
      //history - apply default state
      const historyInitialState = getHistoryInitialState(null);
      setFilterAnswersRequest(historyInitialState);
    }

    setTab(tabKey);
  }


  useEffect(() => {
    setSearchForList([]);
    if (filterNameSchedule != "") {
      filterTaskScheduleRequest.searchText = filterNameSchedule;
      Api.post('/Task/scheduleSearchFor', filterTaskScheduleRequest)
        .then(response => {
          setSearchForList(response.data.response);
        })
        .catch(error => {
          exceptionNotificationAPI(error);
        });
    }
  }, [filterNameSchedule, filterTaskScheduleRequest])

  const [isFormSelected, setIsFormSelected] = useState(false);

  const getFavoriteListData = useCallback(() => {
    Api.post('/Form/getAllFavorite', filterFavoriteRequest)
      .then(response => {
        if (response.data) {
          let formlist = parseFormListToTable(response.data);
          setListFavoritedata(formlist);

          setLoadingTable(false);
          setLoadingTableFavorite(false);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
        setLoadingTableFavorite(false);
      });

    Api.post('/FormTask/getAllApprovalTask', null)
      .then(response => {
        if (response.data) {
          let tasklist = parseTaskListToTable(response.data);
          setListTaskApprovalData(tasklist);

          setLoadingTableApprovalTask(false);
        }
      })
      .catch(error => {
        let message = 'Failed to load the list!';
        if (/500/.test(error.message)) {
          message = t('Prompt.Webserver.Error');
        }
        setLoadingTableApprovalTask(false);
        error_message(message);
      });
  });

  return (
    <Container>
      <ContentPanelIndex>
        {showInfosScreen ? (
          <Tabs activeKey={tab.toString()} onChange={(a) => { handleChangeTab(a) }} style={{ marginTop: -10 }}>
            {can(FEATURE.SCHEDULE, [ACTION.VIEW]) &&
              <TabPane tab={t('Home.TabTitle.Schedule')} key="1" className="pt-6 font-face-gbook">
                <Space className="header-formbuilder-list">
                </Space>
                <Row gutter={[16, 16]}>
                  <Col lg={16} sm={24}>
                    {loadingTableTaskSchedule && <Loading top={0} />}
                    {renderSchedule()}
                  </Col>
                  <Col lg={8} sm={24}>
                    <Row gutter={[16, 16]}>
                      <Col lg={24} sm={24}>
                        <Card>
                          <Title level={5} type="secondary">
                            {t('Home.Schedule.Favorites')}
                          </Title>
                          <Divider />
                          {loadingTableFavorite && <Loading style={{ marginTop: 6 }} />}
                          <div style={{ maxHeight: 340 }}>
                            {!loadingTableFavorite && renderFavoriteTable()}
                          </div>
                        </Card>
                      </Col>
                      <Col lg={24} sm={24}>
                        <Card>
                          <Title level={5} type="secondary">
                            {t('Home.WaitingApproval')}
                          </Title>
                          <Divider />
                          {loadingTableApprovalTask && <Loading style={{ marginTop: 6 }} />}
                          <div style={{ maxHeight: 340 }}>
                            {!loadingTableApprovalTask && renderApprovalTable()}
                          </div>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </TabPane>
            }

            <TabPane tab={t('Home.TabTitle.History')} key="2" className="font-face-gbook">
              {filterAnswersRequest && <>
                <Row gutter={[8, 8]}>
                  <Col lg={24} sm={24}>
                    <Space style={{ position: 'absolute', top: -70, right: 0 }}>
                       <Button
                        type="primary"
                        onClick={() => setShowImportModal(true)}
                        className="btn-show-modal font-face-gbook"
                        icon={<VerticalAlignTopOutlined />}
                      >
                        {t('History.ImportTasks')}
                      </Button> 
                      <Button
                        type="primary"
                        onClick={() => setShowExportModal(true)}
                        className="btn-show-modal font-face-gbook"
                        icon={<ExportOutlined />}
                      >
                        {t('ExportData')}
                      </Button>
                    </Space>
                  </Col>
                  <Col lg={4} sm={12}>
                    <Button.Group style={{ width: '100%' }}>
                      <Button
                        type={!showReportsSummary ? 'primary' : 'default'}
                        icon={<UnorderedListOutlined />}
                        onClick={() => setShowReportsSummary(false)}
                        style={{ flex: 1, height: '32px' }}
                      >
                        {t('Reports.ShowList')}
                      </Button>
                      <Button
                        type={showReportsSummary ? 'primary' : 'default'}
                        icon={<BarChartOutlined />}
                        onClick={() => setShowReportsSummary(true)}
                        style={{ flex: 1, height: '32px' }}
                      >
                        {t('Reports.ShowSummary')}
                      </Button>
                    </Button.Group>
                  </Col>
                  <Col lg={4} sm={12}>
                    <DatePicker.RangePicker
                      style={{ width: '100%' }}
                      value={answersDateRange}
                      allowClear
                      onChange={(dates) => {
                        setAnswersDateRange(dates);
                        if (dates && dates[0] && dates[1]) {
                          // User selected dates, reset the cleared flag
                          setDateRangeCleared(false);
                          setFilterAnswersRequest(prev => ({
                            ...prev,
                            startDate: dates[0].format('YYYY-MM-DD'),
                            endDate: dates[1].format('YYYY-MM-DD'),
                            pageNumber: 1
                          }));
                        } else {
                          // Quando clear é acionado, marca como cleared e envia null para startDate e endDate
                          setDateRangeCleared(true);
                          setFilterAnswersRequest(prev => ({
                            ...prev,
                            startDate: null,
                            endDate: null,
                            pageNumber: 1
                          }));
                        }
                      }}
                      format="YYYY-MMM-DD"
                      locale={{
                        lang: {
                          locale: dayjsLocale,
                          monthFormat: 'MMM',
                          dayFormat: 'DD',
                          yearFormat: 'YYYY',
                          dateFormat: 'YYYY-MMM-DD',
                          dateTimeFormat: 'YYYY-MMM-DD HH:mm:ss',
                          monthBeforeYear: false,
                          yearSuffix: '',
                          monthSuffix: '',
                          daySuffix: '',
                          today: dayjsLocale === 'pt-br' ? 'Hoje' : 'Today',
                          now: dayjsLocale === 'pt-br' ? 'Agora' : 'Now',
                          backToToday: dayjsLocale === 'pt-br' ? 'Voltar para hoje' : 'Back to today',
                          ok: 'OK',
                          timeSelect: dayjsLocale === 'pt-br' ? 'Selecionar hora' : 'Select time',
                          timeSelectLabel: dayjsLocale === 'pt-br' ? 'Selecionar hora' : 'Select time',
                          timeSelectOk: 'OK',
                          timeSelectCancel: dayjsLocale === 'pt-br' ? 'Cancelar' : 'Cancel',
                          dateSelect: dayjsLocale === 'pt-br' ? 'Selecionar data' : 'Select date',
                          dateSelectLabel: dayjsLocale === 'pt-br' ? 'Selecionar data' : 'Select date',
                          dateSelectOk: 'OK',
                          dateSelectCancel: dayjsLocale === 'pt-br' ? 'Cancelar' : 'Cancel',
                          monthSelect: dayjsLocale === 'pt-br' ? 'Selecionar mês' : 'Select month',
                          monthSelectLabel: dayjsLocale === 'pt-br' ? 'Selecionar mês' : 'Select month',
                          monthSelectOk: 'OK',
                          monthSelectCancel: dayjsLocale === 'pt-br' ? 'Cancelar' : 'Cancel',
                          yearSelect: dayjsLocale === 'pt-br' ? 'Selecionar ano' : 'Select year',
                          yearSelectLabel: dayjsLocale === 'pt-br' ? 'Selecionar ano' : 'Select year',
                          yearSelectOk: 'OK',
                          yearSelectCancel: dayjsLocale === 'pt-br' ? 'Cancelar' : 'Cancel',
                          decadeSelect: dayjsLocale === 'pt-br' ? 'Selecionar década' : 'Select decade',
                          decadeSelectLabel: dayjsLocale === 'pt-br' ? 'Selecionar década' : 'Select decade',
                          decadeSelectOk: 'OK',
                          decadeSelectCancel: dayjsLocale === 'pt-br' ? 'Cancelar' : 'Cancel'
                        }
                      }}
                      placeholder={[t('Reports.StartDate'), t('Reports.EndDate')]}
                      disabled={loadingTableAnswers}
                    />
                  </Col>
                  <Col lg={4} sm={12}>
                    <Tooltip title={t('History.SearchPlaceholder')}>
                      <Search
                        placeholder={t('History.SearchPlaceholder')}
                        allowClear
                        ref={historyTextSearchRef}
                        defaultValue={filterAnswersRequest?.searchText}
                        loading={loadingIconAnswersFilter}
                        onSearch={handleAnswersSearchFilter}
                        disabled={loadingTableAnswers}
                      />
                    </Tooltip>
                  </Col>
                  <Col lg={12} sm={12}>
                    {renderAnswersFormDropdown()}
                  </Col>
                </Row>
                <Row gutter={[8, 8]} style={{ marginTop: 12 }}>
                  <Col lg={4} sm={6}>
                    <UserPicker
                      placeholder={t("CreatedBy")}
                      onChange={handleAnswersSearchCreatedUser}
                      value={filterAnswersRequest?.createdBy}
                      disabled={loadingTableAnswers}
                      style={{ width: '100%' }}
                    />
                  </Col>
                  <Col lg={4} sm={6}>
                    <UserPicker
                      placeholder={t("AssignedTo")}
                      onChange={handleAnswersSearchUser}
                      value={filterAnswersRequest?.userId}
                      disabled={loadingTableAnswers}
                      style={{ width: '100%' }}
                    />
                  </Col>
                  <Col lg={4} sm={6}>
                    {renderAnswersTopicDropdown()}
                  </Col>
                  {/* Só mostra filtro de status quando NÃO estiver no modo resumo */}
                  {!showReportsSummary && (
                    <Col lg={4} sm={6}>
                      {renderAnswersStatusDropdown()}
                    </Col>
                  )}
                  <Col lg={4} sm={6}>
                    {renderAnswersReportDropdown()}
                  </Col>
                  <Col lg={4} sm={6}>
                    {renderAnswersLocationDropdown()}
                    {renderAnswersLocationBelowDropdown()}
                  </Col>
                </Row>
              </>}

              <div style={{ marginBottom: 10 }}></div>
              {loadingTableAnswers && <Loading />}
              {!loadingTableAnswers && (
                showReportsSummary && (
                  // Tela de Relatórios Completa
                  <Reports
                    dateRange={answersDateRange}
                    locationId={filterAnswersRequest?.locationId}
                    topicId={filterAnswersRequest?.topicId}
                    includeChildren={filterAnswersRequest?.locationIncludeChildren}
                    reportToHistory={filterAnswersRequest?.reportToHistory}
                    userId={filterAnswersRequest?.userId}
                    createdBy={filterAnswersRequest?.createdBy}
                    status={filterAnswersRequest?.status}
                    searchText={filterAnswersRequest?.searchText}
                    formId={filterAnswersRequest?.formId}
                    user={user}
                    onFormClick={(form) => {
                      setShowReportsSummary(false);
                      // Apply form filter directly
                      if (form) {
                        // Update selectedValue with form name and baseId
                        setSelectedValue({ 
                          label: form.formName || form.name || '', 
                          value: form.baseId 
                        });
                        
                        setFilterAnswersRequest(prev => ({
                          ...prev,
                          formId: form.baseId,
                          formQuestionId: null,
                          formQuestionValue: null,
                          pageNumber: 1
                        }));
                      }
                    }}
                  />
                )
              )}
              {!loadingTableAnswers && !showReportsSummary && renderAnswersTable()}
            </TabPane>

            <TabPane tab={t('Home.TabTitle.AdhocMyActivities')} key="4" className="font-face-gbook">
              <Forms user={user} />
            </TabPane>

            {can(FEATURE.WORKFLOW, [ACTION.ALL, ACTION.HOME]) && <TabPane tab={"Workflow"} key="5" className="font-face-gbook">
              {tab == 5 ? <WorkflowTab /> : null}
            </TabPane>}

            <TabPane tab={"Cockpit"} key="0" className="pt-6">
              {tab == 0 ? <Row gutter={[16, 16]}>
                {!isFormSelected && (
                  <Col lg={24} sm={24}>
                    <QuickActionCards />
                  </Col>
                )}

                <Col lg={isFormSelected ? 24 : 10} sm={24}>
                  <FormBoard onSelectForm={setIsFormSelected} />
                </Col>

                {!isFormSelected && (
                  <Col lg={14} sm={24}>
                    <TaskBoardView
                      t={t}
                      onNavigateToReports={(filters) => {
                        // Navegar para a aba de relatórios com os filtros
                        handleChangeTab('6');
                        // Aqui você pode passar os filtros para o componente Reports
                        // Por exemplo, usando um estado global ou context
                      }}
                    />
                  </Col>
                )}
              </Row> : null}
            </TabPane>

          </Tabs>
        ) : (
          <Loading />
        )}

        {
          showModalFilter && <Modal
            title={"Filter Schedule"}
            style={{ zIndex: '999999 !important' }}
            className="font-face-gbold"
            open={showModalFilter}
            onCancel={() => setShowModalFilter(false)}
            footer=""
            width={750}
          >
            <Divider />

            <Row gutter={[8, 8]} className="font-face-gbook">
              <Col span={12}>
                <strong>{t('History.Tasks')}</strong>
                <Select
                  style={{ width: '100%', marginTop: 5 }}
                  value={filterTaskScheduleRequest.reportToHistory}
                  className="space-search"
                  onChange={(e) => adminSchedule(e)}
                >
                  <Option value={1}>{t('History.MyTasks')}</Option>
                  {user?.showOnlyMyTasks !== true ? <Option value={2}>{t('History.LocationTasks')}</Option> : null}
                  {user?.showOnlyMyTasks !== true ? <Option value={3}>{t('History.ReportTasks')}</Option> : null}
                </Select>
              </Col>
              <Col span={12}>
                <strong style={{ marginBottom: 5 }}>{t('Topic.Title')}</strong>
                <br></br>
                <TreeSelectTopic
                  style={{ width: '100%', marginTop: 5 }}
                  className="space-search"
                  onChange={topicSchedule}
                  value={filterTaskScheduleRequest.topicId}
                ></TreeSelectTopic>
              </Col>
            </Row>

            <Row gutter={[8, 8]} style={{ marginTop: 20 }} className="font-face-gbook">
              <Col span={24}>
                <strong style={{ marginBottom: 5 }}>{t('Status.Task')}</strong>
                {renderScheduleStatusDropdown()}
              </Col>
            </Row>

            <Row gutter={[8, 8]} style={{ marginTop: 20 }} className="font-face-gbook">
              <Col span={24}>
                <strong style={{ marginBottom: 5 }}>{t('DCSearchFor')}</strong>
                <Search
                  allowClear={true}
                  defaultValue={filterNameSchedule}
                  style={{ width: '100%', height: 40, marginTop: 5 }}
                  onSearch={(e) => {
                    setFilterNameSchedule(e);
                    setFilterTaskScheduleRequest({
                      ...filterTaskScheduleRequest,
                      searchText: e
                    });
                  }}
                  className="space-search"
                />
                {searchForList.map((s) => {
                  return <Tag
                    color="#2b579a"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      let calendarApi = calendarRef.current.getApi();
                      calendarApi.gotoDate(moment(s).format());
                      updateSchedule(calendarApi.getDate())
                    }}>
                    {moment(s).format("MM / YYYY")}
                  </Tag>
                })}
              </Col>
            </Row>

            <Row gutter={[8, 8]} style={{ marginTop: 20 }} className="font-face-gbook">
              <Col span={12}>
                <strong style={{ marginBottom: 5 }}>{t('Location')}</strong>
                <TreeSelectLocationUser
                  style={{ width: '100%', marginTop: 5 }}
                  includeDirectParents={false}
                  className="space-search"
                  value={filterTaskScheduleRequest.locationId}
                  onChange={(e) => locationSchedule(e)}
                ></TreeSelectLocationUser>
              </Col>
              <Col span={12}>
                <strong style={{ marginBottom: 5 }}>{t('History.LocationBelow')}</strong>
                <br></br>
                <Switch style={{ marginTop: 15 }} checked={filterTaskScheduleRequest.locationIncludeChildren} onChange={locationBelowSchedule} />
              </Col>
            </Row>
          </Modal>
        }

        <Modal
          title={formTaskSelected != null && formTaskSelected.id ? t("BtnEdit") : t("BtnNew")}
          className="font-face-gbold"
          open={showModalForm}
          onCancel={() => setShowModalForm(false)}
          footer=""
          width={750}
        >
          <ScheduleForm
            formTaskSelected={formTaskSelected}
            dateSelected={dateSelected}
            setShowModalForm={setShowModalForm}
            getTaskScheduleListData={getTaskScheduleListData}
          />
        </Modal>

        <Modal
          title={t('ExportData')}
          className="font-face-gbold"
          open={showExportModal}
          onCancel={() => setShowExportModal(false)}
          footer=""
          width={'60vw'}
        >
          <ExportForm
            closeModal={setShowExportModal}
            statusAnswersList={statusAnswersList}
            baseUserLocation={user?.locationId}
          />
        </Modal>

        <Modal
          title={t('History.ImportTasks') }
          className="font-face-gbold"
          open={showImportModal}
          onCancel={() => setShowImportModal(false)}
          footer=""
          width={750}
        >
          <FormImportTasks formId={filterAnswersRequest?.formId} />
        </Modal>
      </ContentPanelIndex >
    </Container >
  );
};

export default HomeWrapper;
